/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./minecate.vue?vue&type=template&id=138b2309&scoped=true"
import script from "./minecate.vue?vue&type=script&lang=js"
export * from "./minecate.vue?vue&type=script&lang=js"
import style0 from "./minecate.vue?vue&type=style&index=0&id=138b2309&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b2309",
  null
  
)

export default component.exports